import AxiosClient from "../../../services/axios.services";

class ClimaLogServices {
  getClimaLog = (params) =>
    AxiosClient.get("/api/app/logs_clima/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
}

export default new ClimaLogServices();
